import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Checkbox from "./Checkbox";
import Input from "./Input";
import TextArea from "./Textarea";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { useEditor } from "../../../hooks/EditorProvider";
import useFetch from "use-http";
import { useSite } from "../../../hooks/SiteProvider";
import ReCAPTCHA from "react-google-recaptcha";
const Form = ({ id, name, recaptchaPublicKey, className, buttonText, fields, focusKey, }) => {
    const { register, handleSubmit, formState: { errors }, control, setError, reset, setValue, } = useForm();
    const { mode, backendApi } = useEditor();
    const { locale } = useSite();
    const [success, setSucces] = useState(false);
    const { post, response } = useFetch(`${backendApi}/form`);
    const onSubmit = async (data) => {
        if (mode === "editor")
            return;
        setSucces(false);
        const formPost = await post("/", {
            formId: id,
            locale,
            ...data,
        });
        if (formPost?.errors) {
            const errors = formPost.errors;
            Object.keys(errors).forEach((errorKey) => {
                setError(errorKey, {
                    type: "custom",
                    message: errors[errorKey],
                });
            });
        }
        if (response.ok) {
            reset();
            setSucces(response.data);
        }
    };
    return (_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: className, "editor-focuskey": focusKey, children: [success && (_jsx("div", { className: "rounded-md bg-green-50 p-4 sm:col-span-2", children: _jsxs("div", { className: "flex", children: [_jsx("div", { className: "flex-shrink-0", children: _jsx(CheckCircleIcon, { className: "h-5 w-5 text-green-400", "aria-hidden": "true" }) }), _jsx("div", { className: "ml-3", children: _jsx("p", { className: "text-sm font-medium text-green-800", children: success }) }), _jsx("div", { className: "ml-auto pl-3", children: _jsx("div", { className: "-mx-1.5 -my-1.5", children: _jsxs("button", { type: "button", className: "inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50", children: [_jsx("span", { className: "sr-only", children: "Dismiss" }), _jsx(XMarkIcon, { className: "h-5 w-5", "aria-hidden": "true" })] }) }) })] }) })), fields.map((field) => {
                if (field.type === "textarea") {
                    return (_jsx(TextArea, { className: field.grid === "1/1" ? "sm:col-span-2" : "", label: field.label, error: errors[field.name] || null, ...register(field.name) }, field.name));
                }
                if (field.type === "checkbox") {
                    return (_jsx(Controller, { name: field.name, control: control, render: ({ field: propField }) => (_jsx(Checkbox, { className: field.grid === "1/1" ? "sm:col-span-2" : "", label: field.label, error: errors[field.name] || null, ...propField }, field.name)) }, field.name));
                }
                if (field.type === "recaptcha") {
                    if (mode === "editor")
                        return;
                    if (!recaptchaPublicKey)
                        return;
                    return (_jsxs("div", { className: "space-y-2", children: [_jsx(ReCAPTCHA, { sitekey: recaptchaPublicKey, onChange: (value) => setValue(field.name, value) }), errors && errors[field.name] && (_jsx("p", { className: "text-sm text-red-600", id: `${name}-error`, children: errors[field.name]?.message }))] }));
                }
                return (_jsx(Input, { className: field.grid === "1/1" ? "sm:col-span-2" : "", label: field.label, type: field.type === "email" ? "email" : "text", error: errors[field.name] || null, ...register(field.name) }, field.name));
            }), _jsx("div", { className: "sm:col-span-2", children: _jsx("button", { type: "submit", className: "form-button font-text bg-site-600 hover:bg-site-700 focus:ring-site-500 inline-flex w-full items-center justify-center rounded-md border border-transparent px-6 py-3 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2", children: buttonText }) })] }));
};
export default Form;
//# sourceMappingURL=index.js.map